import { render, staticRenderFns } from "./InfoViaje.vue?vue&type=template&id=175b04a8&scoped=true&"
import script from "./InfoViaje.vue?vue&type=script&lang=js&"
export * from "./InfoViaje.vue?vue&type=script&lang=js&"
import style0 from "./InfoViaje.vue?vue&type=style&index=0&id=175b04a8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175b04a8",
  null
  
)

export default component.exports